import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

const tiers = [50, 100, 250, 500, 1000];

export default function AnnualDonor() {
  const { t } = useI18n();
  return (
    <div data-testid="annual-donor-page">
      <section className="hero-gradient py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-warm-orange font-semibold">{t("pages.annual.tag")}</div>
          <h1 className="font-display text-deep-blue text-5xl sm:text-6xl lg:text-7xl leading-tight mt-3">{t("pages.annual.t1")}<br/><span className="italic text-warm-orange">{t("pages.annual.t2")}</span></h1>
        </div>
      </section>
      <section className="py-16 bg-ivory">
        <div className="max-w-6xl mx-auto px-5 lg:px-10 grid md:grid-cols-5 gap-4">
          {tiers.map((amt,i) => (
            <div key={amt} className="rounded-2xl p-6 bg-white border border-black/5" data-testid={`annual-${amt}`}>
              <div className="text-xs uppercase text-warm-orange tracking-widest">{t("annual.levelLabel")} 0{i+1}</div>
              <div className="font-display text-5xl text-deep-blue mt-4">{amt}€<span className="text-sm">{t("annual.perYear")}</span></div>
              <Link to="/faire-un-don" className="btn-ghost-blue mt-6 py-3 rounded-full text-sm font-semibold text-center block">{t("common.commitTier")}</Link>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
